import { Component, OnInit, Inject, Optional } from '@angular/core';
import { NgForm } from '@angular/forms';
import { MatSnackBar, MatDialogRef, MAT_DIALOG_DATA } from '@angular/material';
import { GL_MasterService } from '../../../services/Acc_GL_Master.service';
import { DiscountService } from '../../../services/DiscountService';
@Component({
  selector: 'app-discount-edit-dialog',
  templateUrl: './discount-edit-dialog.component.html',
  styleUrls: ['./discount-edit-dialog.component.css']
})
export class DiscountEditDialogComponent implements OnInit {
  studentID: string;
  discount: string;
  comment: string;
  downloadFileLink: string;
  studentDetails: string;
  constructor(public dialogRef: MatDialogRef<DiscountEditDialogComponent>,
    @Optional() @Inject(MAT_DIALOG_DATA) public data: any, private GL_MasterService: GL_MasterService, private DiscountService: DiscountService) {
    this.studentDetails = data.studentDetails;
    this.studentID = data.studentID;
    this.discount = data.discount;
    this.comment=data.comment;
    this.downloadFileLink=data.link;
    console.log("Inside modal: ");
    console.log("comment"+data.comment);
    console.log(this.studentID + " " + this.studentDetails + " " + this.discount);
  }
  ngOnInit() {
  }
  onSubmit(f: NgForm) {
    this.DiscountService.editDiscount(f.value).subscribe(f => {
      this.dialogRef.close({ event: 'close', data: "Done" });
    });
  }
}



// WEBPACK FOOTER //
// ./src/app/components/discount/discount-edit-dialog/discount-edit-dialog.component.ts